// Gravity Perks - Gravity Wiz Nested Forms

const $ = require('jquery');

// fake entry script
let $nestedEntries = $('.gpnf-contact-participant .gpnf-nested-entries'); 

if ($nestedEntries.length) {
	
	let $entryBody = $nestedEntries.find('tbody').first(),
	$emptyBody = $nestedEntries.find('tbody').last(),
	$form = $('.tab-panel[data-tab-id="business"]').find('form'),
	$contactCursistField = $form.find('.ginput_container_radio input'), 
	entriesHideClass = 'no-entries-hide';

	// on business form change
	$form.on('change', function()  {

		// custom form parameters
		let firstName = $form.find('.name_first input').val(),
		middleName = $form.find('.name_middle input').val(),
		lastName = $form.find('.name_last input').val(), 
		contactCursist = $contactCursistField.first().is(':checked'),
		$fakeEntry = $('.fake-entry'); 

		// check if first name and last name are filed
		if (firstName && lastName && contactCursist) {

			// hide no entries notification
			$emptyBody.addClass(entriesHideClass); 

			if ($fakeEntry.length) {
				// update name 
				$fakeEntry.find('.first-name').html(firstName);
				$fakeEntry.find('.middle-name').html(middleName); 
				$fakeEntry.find('.last-name').html(lastName); 
			} else {
				// construct fake entry
				$fakeRecord = '<tbody class="fake-entry"><tr data-entryid="fake"><td class="gpnf-field first-name">'+ firstName + '</td><td class="gpnf-field middle-name">' + middleName + '</td><td class="gpnf-field last-name">' + lastName +'</td></tr></tbody>'; 
				$entryBody.before($fakeRecord);  
			}
		} else {
			
			// check if fake entry - otherwise remove fake entry
			if ($fakeEntry.length) {

				// delete fake entry and show no entries notification
				$fakeEntry.remove();
				$emptyBody.removeAttr('class'); 
			}
		}

		// check the avaible spots with the nested entries
		checkNestedFormAvailability();
	});

	function checkNestedFormAvailability() {

		// set up variables
		let $addEntryBtns = $('.gpnf-add-entry'),
		$nfEntries = $('tr[data-entryid]'),
		nrOfEntries = 0; 

		// check which entries count
		$nfEntries.each(function() {
			// none visible entries will not be included in the registration proces
			if ($(this).is(':visible')) {
				nrOfEntries++;
			}
		});

		// disable entry buttons if necassary
		$addEntryBtns.each(function() {
			if ($(this).is(':visible')) {
				if (nrOfEntries >= availableSpots) {
					$(this).attr('disabled', true);
				} else {
					// remove disable if still available spots
					$(this).attr('disabled', false);
				}
			}
		});
	}
}

$( document ).bind('gpnf_post_render', function() {
	// replace default field required text or aterisk with icon of choice in nested forms
	$('.gform_wrapper .gfield_required').each( function() {
    	$(this).html('<i class="fas fa-lock"></i>');
	});
});

// remove existing nested form entries to prevent false form data to be submitted
$( document ).ready(function() {

	$formWrapper = $('.tab-panel .gform_wrapper');

	// only when enrollment forms are on page
	if (!$formWrapper.hasClass('gform_validation_error') && $formWrapper.find('form').length){
		removeNestedFormEntries(); 
	}
});

function removeNestedFormEntries() {
	
	// nested form entries
	let $nestedEntries = $('.gpnf-nested-entries tbody tr'); 

	if ($nestedEntries.length) {
		
		// iterate over entry objects
		$nestedEntries.each( function() {

			// only check object with existing entries
			if (!$(this).hasClass('gpnf-no-entries')) {

				// initiate delete 
				$deleteButton = $(this).find('.delete-button');
				$deleteButton.trigger("click");
			}
		});
	}
}